import React from 'react';

const EducationHistoryListing = ({ data, onEdit, onDelete, isLoading }) => {
    const formatDate = (dateStr, accuracy) => {
        if (!dateStr) return '---';
        const parts = dateStr.split('-');
        if (parts.length !== 3) return dateStr;

        const [year, month, day] = parts;
        if (accuracy === 'year') return year;
        if (accuracy === 'month') return `${month}-${year}`;
        return `${day}-${month}-${year}`;
    };

    return (
        <div className="table-card">
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <i className="fa-solid fa-circle-notch fa-spin"></i> Đang tải dữ liệu
                </div>
            ) : data.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666' }}>
                    <i className="fa-solid fa-graduation-cap" style={{ fontSize: '60px', color: '#5dade2', marginBottom: '15px' }}></i>
                    <h3 style={{ color: '#e74c3c', margin: '0 0 10px 0' }}>Chưa có quá trình đào tạo</h3>
                </div>
            ) : (
                <div style={{ overflowX: 'auto', width: '100%' }}>
                    <table className="custom-table" style={{ width: '100%', minWidth: '1100px' }}>
                        <thead>
                            <tr>
                                <th width="5%" style={{ textAlign: 'center' }}>STT</th>
                                <th width="10%">TRÌNH ĐỘ</th>
                                <th width="20%">TẠI TRƯỜNG</th>
                                <th width="12%">NGÀNH</th>
                                <th width="13%">CHUYÊN NGÀNH</th>
                                <th width="10%">QUỐC GIA</th>
                                <th width="10%" style={{ textAlign: 'center' }}>TỪ NGÀY</th>
                                <th width="10%" style={{ textAlign: 'center' }}>ĐẾN NGÀY</th>
                                <th width="10%" style={{ textAlign: 'center' }}>CHỨC NĂNG</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={item.Id}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td>{item.EducationLevel}</td>
                                    <td style={{ fontWeight: '500', color: '#0056b3' }}>{item.School}</td>
                                    <td>{item.Major}</td>
                                    <td>{item.Specialization || '---'}</td>
                                    <td>{item.Country || '---'}</td>
                                    <td style={{ textAlign: 'center' }}>{formatDate(item.StartDate, item.StartDateAccuracy)}</td>
                                    <td style={{ textAlign: 'center' }}>{formatDate(item.EndDate, item.EndDateAccuracy)}</td>
                                    <td>
                                        <div className="action-group" style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                            <div className="icon-wrapper edit-wrapper" onClick={() => onEdit(item)} title="Sửa" style={{ cursor: 'pointer' }}>
                                                <i className="fa-solid fa-pen edit-icon"></i>
                                            </div>
                                            <div className="icon-wrapper delete-wrapper" onClick={() => onDelete(item.Id)} title="Xóa" style={{ cursor: 'pointer' }}>
                                                <i className="fa-solid fa-trash delete-icon"></i>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default EducationHistoryListing;